import { CrudState } from "@/store/Crud/State";

export class State extends CrudState {
  emailExists = false;
  blob: Record<any, any> | null = null;
  mimeType = "";
}
